<template>
   <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <CustomToastContainer />
  </UApp>
</template>

<script setup lang="ts">
import CustomToastContainer from '~/components/toast/CustomToastContainer.vue';
import { useI18nLocale } from '~/composables/useI18nLocale';

const { initLocale } = useI18nLocale();

// 在應用程式啟動時初始化語系
onMounted(() => {
  initLocale();
});
</script>
